<template>
    <div class="card">
        <div class="card-header">
                                <span class="text-warning">
                                    <i class='fa-solid fa-star'></i>
                                    <i class='fa-solid fa-star'></i>
                                    <i class='fa-solid fa-star'></i>
                                    <i class='fa-solid fa-star'></i>
                                    <i class='fa-solid fa-star'></i>
                                </span> {{ title }}
        </div>
        <div class="card-body">
            <blockquote class="blockquote mb-0">
                <div class="testimonial-thumbnail rounded me-3 mb-2  " style="float:left;">
                    <img class="testimonial-image" :src="img_src" alt="Yorick testimonial" style="float:left;">
                </div>
                <p class="text-muted small">
                    <em>
                        {{ text }}
                    </em>
                </p>
                <!--                                    <footer class="blockquote-footer mt-2">-->
                <strong class="mt-2">
                    <a :href="link" class="btn btn-sm btn-outline-primary mb-auto"><i :class="'fa-solid fa-chevron-right me-2'"></i> Lees hier de hele testimonial</a>
                </strong>
                <!--                                    </footer>-->
            </blockquote>
        </div>
    </div>
</template>

<script>

export default {
    components: {},

    props: ['text', 'title', 'img_src', 'link'],

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
<style>
.testimonial-thumbnail {
    width: 100px;
    height: 100px;
    overflow:hidden;
}
.testimonial-image {
    width:100px
}
</style>
